import React from 'react';
import { Col, useTranslation, BasicButtonBG } from '@lib/index';
import { startOidcLogin } from '@helpers/oidcLogin';

const OidcLoginControls = () => {
  const { t } = useTranslation();

  const goToProvider = () => {
    window.location.href = startOidcLogin();
  };

  return (
    <Col xs={24}>
      <BasicButtonBG
        size="large"
        className="mt-4"
        data-cy="login-form-oidc"
        onClick={goToProvider}
        buttonColorType="default"
        text={t('login.ssoLogin')}
        loading={false}
        type="default"
      />
    </Col>
  );
};

export default OidcLoginControls;
